import AlertIcon from "components/portfolio/components/alert/AlertIcon";
import {
  AlertDetail,
  DismissPayload,
  TYPE_TO_VALUE_KEY_MAPPING,
} from "components/portfolio/components/alert/alert-icon-type";
import { Account, AlertOverview } from "types/portfolio";
import { GridReadyEvent } from "ag-grid-community";
import { mutate } from "swr";

const updatePortfolioGrid = (
  payload: DismissPayload,
  gridEvent: GridReadyEvent,
  dismissAll = false
) => {
  const { alertType: type, accountKeys } = payload;
  const valueKey = TYPE_TO_VALUE_KEY_MAPPING[type];
  // update the count on portfolio grid
  const rowNode = gridEvent?.api?.getRowNode(accountKeys?.[0] ?? "");
  if (rowNode) {
    const data: Account = rowNode.data;
    const count = dismissAll ? 0 : (data?.alertsOverview?.[valueKey] ?? 0) - 1;
    const updated = {
      ...data,
      alertsOverview: {
        ...data.alertsOverview,
        [valueKey]: count,
      },
    };
    rowNode.updateData(updated);
    // if all alerts have been dismissed for the account, remove the node from grid
    if (count <= 0) {
      gridEvent?.api?.redrawRows({ rowNodes: [rowNode] });
    }
  }
};

const updateSummaryAlertGrid = (
  payload: DismissPayload,
  gridEvent: GridReadyEvent,
  dismissAll = false
) => {
  const { alertId: id, alertType: type } = payload;
  gridEvent?.api?.forEachNode((node) => {
    if (dismissAll && type) {
      if (node.data.type === type) {
        node.data.dismissed = true;
      }
    }
  });
  gridEvent?.api?.redrawRows();
  if (id) {
    const rowNode = gridEvent?.api?.getRowNode(id);
    const data: Account = rowNode?.data;
    const updated = {
      ...data,
      dismissed: true,
    };
    rowNode.updateData(updated);
    gridEvent?.api?.redrawRows({ rowNodes: [rowNode] });
  }
};

export const dismissCallback = (
  payload: DismissPayload,
  gridEvent?: GridReadyEvent,
  mutateKeys?: string[],
  accountLevelMutateKeys?: string[]
) => {
  const { alertType, accountKeys, alertId, dismissAllCount } = payload;
  const dismissAll = !payload.alertId;

  // dismiss all will remove the icon by the parent, so only handle dismiss one
  if (!dismissAll) {
    mutate(
      `/api/dataservice/v1/accounts/${accountKeys?.[0]}/alerts${`?alertType=${alertType}`}`,
      (prv?: AlertDetail[]) => prv?.filter((x) => x.id !== alertId),
      false
    );
  }

  // update the count on portfolio grid
  if (gridEvent) {
    if (gridEvent.type === "portfolio") {
      updatePortfolioGrid(payload, gridEvent, dismissAll);
    } else {
      updateSummaryAlertGrid(payload, gridEvent, dismissAll);
    }
  }
  if (accountLevelMutateKeys) {
    accountLevelMutateKeys.forEach((x) => mutate(x));
  }
  if (mutateKeys) {
    mutateKeys.forEach((key) => {
      mutate(
        key,
        (prv?: AlertOverview) =>
          prv
            ? {
                ...prv,
                [TYPE_TO_VALUE_KEY_MAPPING[alertType]]:
                  prv[TYPE_TO_VALUE_KEY_MAPPING[alertType]] - (dismissAllCount ?? 1),
              }
            : undefined,
        false
      );
    });
  }
};

export default AlertIcon;
